// 列表标签显示
import { defineStore } from 'pinia'


export const siderStore = defineStore({
    persist: {
        enabled: true, // 是否启用持久化
        strategies: [
            {
                key:"siderStore",//自定义存储名称
                storage: localStorage, // 存储介质，可以是 localStorage、localStorage 等
            },
        ],
    },
    // 唯一的名称，如 id
    id: 'siderStore',
    // 状态定义 (数据源)
    state: () => ({
        activeId: String,
        tabUrl: String,
        isCollapse : false
    }),
    // 可选的 actions
    actions: {
        setTabStore(newUrl) {
            this.tabUrl=newUrl;
        },
        handleOpen() {
            this.isCollapse=true;
        },
        handleClose() {
            this.isCollapse=false;
        }
    }
})